// extracted by mini-css-extract-plugin
module.exports = {"notificationsOverlay":"LX"};